import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Allocation } from '@lib/models/generated/graphql';
import { DocumentsService, FicheStorageFile } from '@lib/services/documents.service';
import { AllocationService } from 'src/app/services/allocation.service';
@Component({
  selector: 'app-add-fichier-allocation-dialog',
  templateUrl: './add-fichier-allocation-dialog.component.html',
  styleUrls: ['./add-fichier-allocation-dialog.component.scss'],
})
export class AddFichierAllocationDialogComponent {
  isloading: boolean = false;
  files: FicheStorageFile[] | null;

  initFiles: FicheStorageFile[] = [];
  fakeCurrentFile: File | undefined; // use for oui-file-item

  constructor(
    @Inject(MAT_DIALOG_DATA)
    private data: { allocation: Allocation },
    private dialogRef: MatDialogRef<AddFichierAllocationDialogComponent>,
    private documentService: DocumentsService,
    private allocationService: AllocationService
  ) {}

  ngOnInit(): void {
    if (this.data.allocation.storageFile?.fileName) {
      this.fakeCurrentFile = new File([], this.data.allocation.storageFile?.fileName, {
        type: this.data.allocation.storageFile?.fileType,
      });
    }
  }
  onFileChange(files: File[] | null) {
  }
  deleteFile(fileToDelete: FicheStorageFile) {
    this.files = this.files?.filter(file => file.name !== fileToDelete.name) ?? null;
  }
  onValid() {
    this.isloading = true;
    if (this.files) {
      this.documentService
        .uploadFicheStorageFiles(this.files)
        .then((storageFiles: FicheStorageFile[]) => {
          // all files are uploaded create config
          let filesIds: string[] = storageFiles
            .map(file => file.storageFile?.id)
            .filter(id => id !== undefined) as string[];
          this.allocationService.updateAllocationStorageFile(this.data.allocation.id, filesIds[0]).then(() => {
            this.dialogRef.close(storageFiles);
            this.isloading = false;
          });
        })
        .catch(() => {
          this.isloading = false;
        });
    } else {
      this.allocationService.updateAllocationStorageFile(this.data.allocation.id, null)
      .then(() => {
        this.dialogRef.close();
        this.isloading = false;
      }).catch(() => {
        this.isloading = false;
      });
    }
  }

  async onCurrentFileClick($event: File) {
    await this.documentService.displayStorageFileInNewTab(this.data.allocation.storageFile!);
  }
  deleteCurrentFile($event: File) {
    this.fakeCurrentFile = undefined;
  }
}
